import React, { useMemo } from 'react';
import { sortBy as _sortBy } from 'lodash';
import ReactCountryFlag from 'react-country-flag';
import { styled } from '@mui/material/styles';
//
import { GROUP_BY_FILTER_TYPES } from '../../../../constants/reports';

const CustomTooltipListWrapper = styled('div')(() => ({
  background: 'white',
  border: '1px solid #ccc',
  padding: 10,
  fontSize: 14,
  zIndex: 10,
}));

const CustomTooltipListItem = styled('li')(() => ({
  listStyle: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: 6,
}));

const CustomTooltipItem = ({ entry, formatter }) => {
  return (
    <CustomTooltipListItem style={{ color: entry.color }}>
      <span>
        {entry.name}: {formatter(entry.value)}
      </span>
    </CustomTooltipListItem>
  );
};

const CustomTooltipItemGeo = ({ entry, formatter }) => {
  const code = entry.name;

  return (
    <CustomTooltipListItem>
      {code === '' ? (
        'N/A'
      ) : (
        <ReactCountryFlag
          countryCode={code}
          svg
          style={{
            width: '1.5em',
            height: '1.5em',
            borderRadius: 2,
          }}
        />
      )}

      <span style={{ color: entry.color }}>: {formatter(entry.value)}</span>
    </CustomTooltipListItem>
  );
};

export const CustomTooltip = ({
  active,
  payload,
  label,
  formatter,
  groupBy,
}) => {
  const sortedPayload = _sortBy(payload, ['value']).reverse();

  const Renderer = useMemo(
    () =>
      groupBy === GROUP_BY_FILTER_TYPES.GEO
        ? CustomTooltipItemGeo
        : CustomTooltipItem,
    [groupBy],
  );

  if (!active || !payload) return null;
  return (
    <CustomTooltipListWrapper>
      <strong>{label}</strong>
      <ul style={{ paddingLeft: 0, marginTop: 5 }}>
        {sortedPayload.map((entry, index) => (
          <Renderer key={index} entry={entry} formatter={formatter} />
        ))}
      </ul>
    </CustomTooltipListWrapper>
  );
};
